// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M10 3.91421V0.5H12V3.91421H10Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M7.41436 5.49917L5.00015 3.08496L3.58594 4.49917L6.00015 6.91339L7.41436 5.49917Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M10.9999 4.81055C9.75169 4.81055 8.73986 5.82239 8.73986 7.07055V15.1342L6.06333 14.6054C5.31798 14.4582 4.55733 14.7744 4.13607 15.4067L3.18652 16.8319L7.48485 22.4232C8.00666 23.1019 8.81424 23.4997 9.67042 23.4997H16.7559C17.9427 23.4997 18.9963 22.7402 19.3714 21.6143L21.1538 16.2637C21.566 15.0262 21.0545 13.6691 19.928 13.0116L16.3033 10.8959C15.8816 10.6497 15.402 10.52 14.9137 10.52H13.2599V7.07055C13.2599 5.82238 12.248 4.81055 10.9999 4.81055Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M16.9998 3.08496L14.5856 5.49917L15.9998 6.91339L18.4141 4.49917L16.9998 3.08496Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-gesture-click-filled')
export default class GestureClickFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'gesture-click-filled',
    }
  }
}
